import { render } from "./sections.vue?vue&type=template&id=a2c860b8&scoped=true"
import script from "./sections.vue?vue&type=script&lang=js"
export * from "./sections.vue?vue&type=script&lang=js"

import "./sections.vue?vue&type=style&index=0&id=a2c860b8&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2c860b8"]])

export default __exports__